const UPPERCASE = /[A-Z]/;

const NORDIC_CHARACTERS = /[æøåÆØÅ]/;

export const createAbsoluteUrl = (relativeUrl: string) =>
    new URL(relativeUrl, process.env.NEXT_PUBLIC_URL);

export const containsUpperOrNordicChars = (relativeUrl: string) => {
    try {
        const url = createAbsoluteUrl(relativeUrl);
        const decodedPath = decodeURIComponent(url.pathname);
        return UPPERCASE.test(decodedPath) || NORDIC_CHARACTERS.test(decodedPath);
    } catch {
        // In case new URL() returns an error, we will return false.
        return false;
    }
};

/**
 * Normalizes a URL to ensure its pathname has:
 *   1) Nordic characters replaced with their ASCII fallback (æ→ae, ø→oe, å→aa)
 *   2) Is converted to lowercase
 *   3) Leaves query intact.
 */
export const normalizePath = (relativeUrl: string) => {
    const url = createAbsoluteUrl(relativeUrl);

    const decodedPath = decodeURIComponent(url.pathname);

    let replaced = decodedPath
        .replace(/[æÆ]/g, 'ae')
        .replace(/[øØ]/g, 'oe')
        .replace(/[åÅ]/g, 'aa')
        .toLowerCase();

    replaced = encodeURI(replaced);

    url.pathname = replaced;
    return url.toString();
};
